import { plainToClass } from 'class-transformer';
import { CountUp } from 'countup.js';
import { SampleSearchResult, SortColumn } from './sample-search.entities';
import _ from "lodash";
import "jQuery-QueryBuilder/dist/js/query-builder.standalone.js";
import { SearchManagement } from '../scripts/sample-search.search-management';
import { UserQuery } from '../../../../shared/entities/user-query/user-query.entities';

declare var $: any;

export class InventorySearchPage {
    filters: any[];
    rules: any;
    variableMap: Map<string, string>;
    filterMap: Map<string, string>;
    updatingRules: boolean = false;
    resultsTable: any;
    currentResults: SampleSearchResult[] = [];
    storedSort: any[];
    sortedResults: SampleSearchResult[] = [];
    columnIndex: SortColumn[] = [];

    searchManagement: SearchManagement;
    adminSearchManagement: SearchManagement;

    private static readonly MAX_GROUP_DEPTH = 12;   
    private static readonly MAX_TOTAL_NODES = 60;

    constructor(filters: any[], savedQueries: any, allQueries: any, startInAdmin: boolean = false, queryId: string = "-1", isAdmin: boolean = false, summaryStatsJson: any) {
        $(() => {
            $('.search-results').hide();
            let summaryStats: SummaryStats = plainToClass(SummaryStats, <SummaryStats>summaryStatsJson || 0);
            this.startCounter('participant-count', summaryStats.TotalParticipants || 0);
            this.startCounter('sample-count', summaryStats.TotalSamples || 0);
            this.startCounter('unit-count', summaryStats.TotalUnits || 0);

            this.searchManagement = new SearchManagement(savedQueries, this);

            this.initFilters(filters);
            this.initRules();
            this.initQueryBuilder();
            this.initializeTable(isAdmin);

            this.adminSearchManagement = new SearchManagement(allQueries, this, true, startInAdmin, queryId);

            $(".modal").on("shown.bs.modal", (e: Event) => {
                let targetElement = $(e.target).find(".scroll-modal-body");
                targetElement.animate({
                    scrollTop: 0
                }, 250)
            })

            if (!startInAdmin && queryId != "-1") {
                this.searchManagement.initializeParsedQuery(queryId);
            }
        });
    }

    initFilters(filters: any[]) {
        //console.log("Filters received:", filters);

        this.variableMap = new Map();
        this.filterMap = new Map();

        this.filters = filters.map((filter: any) => {
            if (filter.plugin == "slider") {
                filter.plugin_config.min = +filter.plugin_config.min; //cast to number
                filter.plugin_config.max = +filter.plugin_config.max;
                filter.plugin_config.value = +filter.plugin_config.value;

                filter.onAfterSetValue = function (rule, value) {
                    var input = rule.$el.find('.rule-value-container input');
                    input.slider('setValue', value);
                    input.val(value);
                }
            }
            this.variableMap.set(filter.id, filter.label.replace(/ /g, "_"));

            if ((filter.type == "integer" || filter.type == "string") && (filter.input == "radio" || filter.input == "select")) {
                if (Array.isArray(filter.values)) {
                    filter.values.forEach((option: any, idx: number) => {
                        this.filterMap.set(filter.id + "@" + option.value, option.label);
                    });
                }
            }
            return filter;
        });
    }

    initRules(): any {
        this.rules = {
            condition: 'AND',
            rules: [
                {
                    "field": "StatusId",
                    "id": "StatusId",
                    "input": "select",
                    "operator": "equal",
                    "type": "integer",
                    "value": 2
                }
            ]
        };
    }

    initQueryBuilder() {
        //console.log("jQuery version:", $.fn.jquery);
        //console.log("QueryBuilder loaded?", typeof $.fn.queryBuilder);

        $('#builder').queryBuilder({
            filters: this.filters,
            rules: this.rules,
            icons: {
                add_group: 'fas fa-plus-square',
                add_rule: 'fas fa-plus',
                remove_group: 'fas fa-minus-square',
                remove_rule: 'fas fa-trash-alt',
                error: 'fas fa-exclamation-circle'
            },
            lang: {
                delete_group: ' ',
                delete_rule: ' ',

            }
        });       

        $('#builder').on('rulesChanged.queryBuilder', () => {
            if (this.updatingRules) return;

            this.rules = $('#builder').queryBuilder('getRules');

            if (!this.validateRulesOrShowError(this.rules)) {
                return;
            }

            const sqlObj = $('#builder').queryBuilder('getSQL', 'named');
            if (!sqlObj) {
                $('#generated-sql').text("");              
                $('#save-button').prop('disabled', true);
                return;
            }

            let formattedSql: string = sqlObj.sql;
            let labelsMap: Map<string, string> = new Map<string, string>();

            for (const key in sqlObj.params) {
                if (sqlObj.params.hasOwnProperty(key)) {
                    formattedSql = formattedSql.replace(":" + key, this.getFilterValue(key, sqlObj.params[key]));

                    let filterId = this.extractFilterId(key);
                    if (!labelsMap.has(filterId)) {
                        labelsMap.set(filterId, this.variableMap.get(filterId));
                    }
                }
            }

            labelsMap.forEach((value, key) => {
                formattedSql = formattedSql.split(key).join(value);
            });

            $('#generated-sql').text(formattedSql);
            $('#save-button').prop('disabled', false);
        });
        $('#builder').trigger('rulesChanged.queryBuilder');
    }

    extractFilterId(key: string) {

        let filterId: string = key.substring(0, key.lastIndexOf("_"));
        return filterId;
    }

    getFilterValue(key: string, value: any) {

        let filterId: string = this.extractFilterId(key);
        let filterMapKey: string = filterId + "@" + value;

        let mappedValue: string = this.filterMap.get(filterMapKey);

        if (mappedValue) return "\"" + mappedValue + "\"";
        else return value;
    }

    search(): void {

        this.rules = $('#builder').queryBuilder('getRules');
        //console.log("DEPTH:", this.getMaxDepth(this.rules), "NODES:", this.countNodes(this.rules), this.rules);

        if (!this.validateRulesOrShowError(this.rules)) {
            // Don't show loading spinner if we aren't actually searching
            $("#loading-results-display").addClass("d-none");
            return;
        }

        $("#loading-results-display").removeClass("d-none");

        $.ajax({
            type: "POST",
            //url: '/secure/biospecimens/inventory-search/inventory-search?handler=Search',
            url: '/secure/biospecimens/inventory-search?handler=Search',
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify(this.rules),
            headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
            success: (response) => {
                let results: SampleSearchResult[] = plainToClass(SampleSearchResult, <SampleSearchResult[]>response.results);
                results.forEach((result: SampleSearchResult) => result.initialize && result.initialize());
                this.currentResults = results;
                //console.log(this.currentResults);
                let patientSet: Set<string> = new Set<string>();
                let sampleSet: Set<string> = new Set<string>();
                let unitSet: Set<string> = new Set<string>();

                results.forEach((result: SampleSearchResult) => {
                    result.initialize();
                    patientSet.add(result.SubjectId.toString());
                    sampleSet.add(result.ParentSampleId.toString());
                    unitSet.add(result.SampleId.toString());
                });
                this.currentResults = results;
                this.storedSort = undefined;
                this.resultsTable.clear();
                //this.resultsTable.rows.add(results);
                this.resultsTable.draw();

                $('.search-results').show();
                $('#query-results-table').DataTable().columns.adjust()

                this.startCounter('participant-count', patientSet.size);
                $('#participants-title').text("Participants");
                this.startCounter('sample-count', sampleSet.size);
                $('#samples-title').text("Samples");
                this.startCounter('unit-count', unitSet.size);
                $('#units-title').text("Aliquots/Tubes");

                $("#loading-results-display").addClass("d-none");
            },
            error: (response) => {
                console.log("error", response);
                alert("An unexpected error occurred. Please try again.");
            }
        });
    }

    saveSearch(): void {
        this.searchManagement.saveSearch(JSON.stringify(this.rules), $('#generated-sql').text() + "");
    }

    deleteSearch(): void {
        this.searchManagement.showDeleteModal();
    }

    cloneSearch(): void {
        this.searchManagement.cloneSearch(JSON.stringify(this.rules), $('#generated-sql').text() + "");
    }

    updateQueryBuilder(query: UserQuery): void {

        this.updatingRules = true;
        $('#builder').queryBuilder('reset');

        if (query == undefined) {
            this.initRules();
            $('#builder').queryBuilder('setRules', this.rules);
        }
        else {
            $('#builder').queryBuilder('setRules', JSON.parse(query.queryJson));
        }

        this.updatingRules = false;
        $('#builder').trigger('rulesChanged.queryBuilder');
    }

    initializeTable(isAdmin: boolean): void {
        this.columnIndex = [
            new SortColumn(0, "Study", "string"),
            new SortColumn(1, "Sample", "string"),
            new SortColumn(2, "Patient", "string"),
            new SortColumn(3, "Unit", "string"),
            new SortColumn(4, "Visit Name", "string"),
            new SortColumn(5, "Sample Type", "string"),
            new SortColumn(6, "Status", "string"),
            new SortColumn(7, "Volume", "number"),
            new SortColumn(8, "Thaw Count", "number"),
            new SortColumn(9, "Target Day", "number"),
            new SortColumn(10, "Unit Type", "string"),
        ]

        let domString = 'lfprti';

        if (isAdmin) {
            domString = 'Blfprti'
        }

        this.resultsTable = $('#query-results-table').DataTable({
            retrieve: true,
            dom: domString,
            autoWidth: false,
            info: false,
            paging: true,
            ordering: false,
            scroller: {
                boundaryScale: 0.75, // start loading new content when you are 25% through the currently loaded content
                displayBuffer: 100, // Number of 'pages' of content that are loaded each draw (9 is default)
                serverWait: 0 // how long to wait after reaching end of scroll before requesting more data, in ms (200 by default)
            },
            scrollX: true,
            searching: false,
            scrollY: "500px",
            scrollCollapse: true,
            language: {
                lengthMenu: "Show _MENU_ Aliquots"
            },
            columns: [
                { data: "Study" },
                { data: "Patient", class: "text-left" },
                { data: "SampleType" },
                { data: "Unit" },                // Sample ID (Unit)
                { data: "Sample" },              // Parent Sample ID (Biospecimen)
                { data: "VisitName" },
                { data: "Status" },
                { data: "Volume" },
                { data: "ThawCount" },
                { data: "TargetDay" },
                { data: "UnitType" }
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    customize: (csv) => {
                        let modifiedCSV = this.convertToCSV(this.currentResults);
                        return modifiedCSV;
                    }
                }
            ],
            ajax: (data, callback, settings) => {
                let out = [];

                let isCurrentSort: boolean = true;
                if (this.storedSort != undefined) {
                    for (let i = 0; i < this.storedSort.length; i++) {
                        let storedOrder = this.storedSort[i];
                        let matchedOrder = data.order[i];
                        if (matchedOrder) {
                            if (storedOrder.column != matchedOrder.column || storedOrder.dir != matchedOrder.dir) {
                                isCurrentSort = false;
                                break;
                            }
                        }
                        else {
                            isCurrentSort = false;
                            break;
                        }
                    }
                }
                else {
                    isCurrentSort = false;
                }

                if (!isCurrentSort) {
                    let sortedResults = _.cloneDeep(this.currentResults);
                    this.storedSort = data.order;

                    for (let i = 0; i < data.order.length; i++) {
                        let order = data.order[i];
                        let colIndex = order.column;
                        let direction = order.dir;

                        let foundSortColumn = this.columnIndex.find(sortColumn => sortColumn.colIndex == colIndex);
                        if (foundSortColumn) {
                            sortedResults = sortedResults.sort((x1, x2): number => {
                                if (foundSortColumn.type == "string") {
                                    let value1: string = _.get(x1, foundSortColumn.propertyName) ?? "";
                                    let value2: string = _.get(x2, foundSortColumn.propertyName) ?? "";
                                    if (direction == "asc") {
                                        return value1.localeCompare(value2);
                                    }
                                    else {
                                        return value2.localeCompare(value1);
                                    }
                                }

                                else if (foundSortColumn.type == "number") {
                                    let value1: number = _.get(x1, foundSortColumn.propertyName);
                                    let value2: number = _.get(x2, foundSortColumn.propertyName);
                                    if (direction == "asc") {
                                        if (value1 < 0 && value2 >= 0) {
                                            return 1;
                                        }
                                        else if (value2 < 0 && value1 >= 0) {
                                            return -1;
                                        }
                                        return value1 - value2;
                                    }
                                    else {
                                        if (value1 < 0 && value2 >= 0) {
                                            return -1;
                                        }
                                        else if (value2 < 0 && value1 >= 0) {
                                            return 1;
                                        }
                                        return value2 - value1;
                                    }
                                }
                            })
                        }
                    }

                    this.sortedResults = sortedResults;
                }

                for (var i = data.start, ien = data.start + data.length; i < ien; i++) {
                    if (this.sortedResults[i] != undefined) {
                        out.push(this.sortedResults[i]);
                    }
                }

                callback({
                    draw: data.draw,
                    data: out,
                    recordsTotal: this.currentResults.length,
                    recordsFiltered: this.currentResults.length
                });
            },
            serverSide: true
        });
    }

    startCounter(elementId: string, value: number): void {
        if (value == undefined) { value = 0; }
        let counter = new CountUp(elementId, value, { useEasing: false, duration: 1 });
        counter.start();
    }

    searchById(): void {
        this.adminSearchManagement.searchById($("#search-input-id").val());
    }

    private convertToCSV(results: SampleSearchResult[]): string {
        let csvArray = [
            [
                "\"Study\"",
                "\"Participant\"",
                "\"Sample Type\"",
                "\"Sample ID (Unit)\"",
                "\"Parent Sample ID (Biospecimen)\"",
                "\"Visit Name\"",
                "\"Status\"",
                "\"Volume\"",
                "\"Thaw Count\"",
                "\"Target Day\"",
                "\"Unit Type\"",
            ],

            ...results.map(item => [
                `\"${item.Study}\"`,
                `\"${item.SubjectId}\"`,           // Participant
                `\"${item.SampleType}\"`,
                `\"${item.SampleId}\"`,            // Sample ID (Unit)
                `\"${item.ParentSampleId}\"`,      // Parent Sample ID (Biospecimen)
                `\"${item.VisitName}\"`,
                `\"${item.Status}\"`,
                `\"${item.Volume}\"`,
                `\"${item.ThawCount}\"`,
                `\"${item.TargetDay}\"`,
                `\"${item.UnitType}\"`,
            ])
        ];
        let csvJoined = csvArray.map(item => item.join(","));
        let csvString = csvJoined.join("\n");
        return csvString;
    }

    private countNodes(node: any): number {
        if (!node) return 0;
        if (Array.isArray(node.rules)) {
            return 1 + node.rules.reduce((sum: number, r: any) => sum + this.countNodes(r), 0);
        }
        return 1;
    }

    private getMaxDepth(node: any): number {
        if (!node) return 0;

        if (!Array.isArray(node.rules)) return 1;

        if (node.rules.length === 0) return 1;

        let maxChildDepth = 0;
        for (const child of node.rules) {
            maxChildDepth = Math.max(maxChildDepth, this.getMaxDepth(child));
        }
        return 1 + maxChildDepth;
    }

    private showBuilderError(msg: string): void {
        $('#generated-sql').html(`<div class="error-msg">${_.escape(msg)}</div>`);
        $('#save-button').prop('disabled', true);
    }

    private validateRulesOrShowError(rules: any): boolean {
        if (!rules) {
            this.showBuilderError("Your search has invalid rules. Please fix highlighted fields.");
            return false;
        }

        const depth = this.getMaxDepth(rules);
        if (depth > InventorySearchPage.MAX_GROUP_DEPTH) {
            this.showBuilderError(
                `Too many nested groups. Please remove some nested groups.`
            );
            return false;
        }

        const nodes = this.countNodes(rules);
        if (nodes > InventorySearchPage.MAX_TOTAL_NODES) {
            this.showBuilderError(
                `Your search is too complex. Please remove some rules/groups.`
            );
            return false;
        }

        return true;
    }
}

export class SummaryStats {
    TotalParticipants: number;
    TotalSamples: number;
    TotalUnits: number;
}